import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, OutlinedInput, Typography, Stack } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import Slide from "@mui/material/Slide";
import { useSelector } from "react-redux";
import notifier from "../Notifier";
import { useHistory } from "react-router-dom";
import ApiService from "./../../services/api-service";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TipPopup(props) {
  const { t } = useTranslation("common");
  const { bal, hbar, matic, near } = useSelector((state) => state.balance);
  const [currency, setCurrecy] = React.useState("siki");
  const history = useHistory();
  const [balance, setBalance] = React.useState(
    localStorage.getItem("balance") ? localStorage.getItem("balance") : 0
  );
  const [inUsd, setInUsd] = React.useState(0);
  const [charge, setCharge] = React.useState({});
  const [amount, setAmount] = React.useState("");
  const [inputValue, setInputValue] = React.useState(false);
  const handleClick = () => {
    notifier.info("You don't have sufficient SIKI tokens to send TIP.");
    // props.handleClose(false);
    // history.push(
    //   `/add-siki-token?${serialize({
    //     token: getToken(),
    //     hbar: getHbar(),
    //     walletId: getWalletId(),
    //     usdc: getUsdt(),
    //   })}`
    // );
  };

  const handleBlur = () => {
    if (amount && currency === "siki" && bal < amount)
      notifier.info("you dont have sufficient balance in your wallet");
    else if (amount && currency === "hbar" && hbar < amount)
      notifier.info("you dont have sufficient balance in your wallet");
  };

  const handleChange = (event) => {
    setCurrecy(event.target.value);
    calculate(amount, event.target.value);
    // if (event.target.value === "siki" && bal < parseInt(amount))
    //   notifier.info("you dont have sufficient balance in your wallet");
    // else if (event.target.value === "hbar" && hbar < parseInt(amount))
    //   notifier.info("you dont have sufficient balance in your wallet");
  };
  const getChanges = async () => {
    try {
      const response = await ApiService.CHARGES();
      if (response["result"]) {
        setCharge({ ...response["result"] });
      }
    } catch (error) {}
  };

  const calculate = async (amount, currency) => {
    if (charge["rate"] && currency === "siki") {
      const usd = charge["rate"] * amount;
      setInUsd(usd);
    } else if (charge["hbarValueInUsd"] && currency === "hbar") {
      const usd = charge["hbarValueInUsd"] * amount;
      setInUsd(usd);
    } else if (charge["maticValueInUsd"] && currency === "matic") {
      const usd = charge["maticValueInUsd"] * amount;
      setInUsd(usd);
    } else {
      const usd = charge["nearValueInUsd"] * amount;
      setInUsd(usd);
    }
  };
  React.useEffect(() => {
    getChanges();
  }, []);

  const amountNumber = (e) => {
    if (amount < 1) {
      if (e.key.includes(".")) {
        setInputValue(true);
      } else if (amount === 0) {
        setInputValue(false);
        setAmount(amount);
      }
    }
  };
  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          props["backdropOff"]
            ? props.handleClose(true)
            : props.handleClose(false);
        }}
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,

            margin: "0",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack
          spacing={1}
          sx={{
            // backgroundColor: "#1E1E1E",
            backgroundColor: "#171515",
          }}
        >
          {props["artist"] ? (
            <Stack sx={{ borderBottom: "2px dashed #4D4D4D", padding: "16px" }}>
              <Typography className="fs-17">{t("tipPopup.title")}</Typography>
              <Typography className="fs-14">
                {" "}
                {props.isPlaylist
                  ? t("tipPopup.text1")
                  : t("tipPopup.text2")}{" "}
                Name ({props["artist"]})
              </Typography>
            </Stack>
          ) : (
            <Stack
              sx={{
                borderBottom: "2px dashed #4D4D4D",
                padding: "16px",
                textTransform: "capitalize",
              }}
            >
              <Typography className="fs-17">{t("loader.message12")}</Typography>
            </Stack>
          )}
          <Stack sx={{ padding: "16px" }}>
            <Typography className="fs-14">{t("tipPopup.lebel")}</Typography>
            <DialogContent sx={{ padding: 0 }}>
              <OutlinedInput
                type="number"
                sx={{ width: "100%", height: "50px !important" }}
                autoFocus
                margin="dense"
                id="name"
                placeholder={t("tipPopup.placeholder")}
                value={inputValue ? +amount : amount}
                onChange={(e) => {
                  inputValue
                    ? setAmount(+e.target.value)
                    : setAmount(e.target.value);
                  calculate(e.target.value, currency);
                }}
                onKeyDown={(e) => {
                  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
                  amountNumber(e);
                }}
                autoComplete="off"
              />

              <Typography
                sx={{
                  color: "#F48706 !important",
                  padding: "5px",
                  fontSize: "12px !important",
                }}
              >
                {t("tipPopup.hint")}{" "}
                {currency === "siki"
                  ? bal.toFixed(2)
                  : currency === "hbar"
                  ? hbar.toFixed(2)
                  : currency === "matic"
                  ? matic.toFixed(2)
                  : near.toFixed(2)}{" "}
                {currency} Coins
              </Typography>
              {inUsd ? (
                <Typography
                  sx={{
                    color: "#F48706 !important",
                    padding: "5px",
                    fontSize: "12px !important",
                  }}
                >
                  {amount} {currency} = {inUsd.toFixed(2)} $
                </Typography>
              ) : null}
            </DialogContent>
            <Stack>
              <Typography className="fs-14">{t("tipPopup.note")}</Typography>
              <Typography className="fs-14">Pay using</Typography>

              <RadioGroup
                sx={{
                  display: "grid",
                  justifyContent: "space-between",
                  gridTemplateColumns: "auto auto auto",
                }}
                aria-labelledby="currency type"
                name="select token type"
                value={currency}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="siki"
                  control={<Radio />}
                  label={
                    <Typography color="default" className="fs-13">
                      SIKI Coins
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="hbar"
                  control={<Radio />}
                  label={
                    <Typography color="default" className="fs-13">
                      HBar
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="matic"
                  control={<Radio />}
                  label={
                    <Typography color="default" className="fs-13">
                      MATIC
                    </Typography>
                  }
                />
                <FormControlLabel
                  value="near"
                  control={<Radio />}
                  label={
                    <Typography color="default" className="fs-13 ">
                      Near
                    </Typography>
                  }
                />
              </RadioGroup>
            </Stack>
            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="default"
                onClick={() => props.handleClose(false)}
              >
                {t("tipPopup.button1")}
              </Button>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                variant="contained"
                color="primary"
                onClick={() => {
                  console.log('TipPopup submit:', {
                    amount,
                    id: props.id,
                    type: props.isPlaylist ? "playlist" : props.isArtist ? "artist" : "music",
                    currency
                  });
                  props.handleClose(
                    amount,
                    props.id,
                    props.isPlaylist
                      ? "playlist"
                      : props.isArtist
                      ? "artist"
                      : "music",
                    currency
                  );
                }}
                disabled={!amount}
              >
                {t("tipPopup.button2")}
              </Button>
            </DialogActions>
          </Stack>
        </Stack>
      </Dialog>
    </div>
  );
}
